<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="id"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入规则名称" @search="onSearch" style="max-width: 400px;"/>
        <a-button style="margin-left: 10px" type="primary" icon="plus" @click="createCodeEvent(0,0)">新建</a-button>
      </a-form-item>
      <div slot="action" slot-scope="data">
        <a @click="createCodeEvent(data.record.id,data.record.status)">查看</a>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
export default {
  name: 'AutoReplyList',
  data() {
    return {
      submitLoading: false,
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        name: '',
        platformId: this.getPlatformConfig().platformId,
        type: 2
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '规则名称',
          dataIndex: 'name'
        },
        {
          title: '回复场景',
          dataIndex: 'type'
        },
        {
          title: '创建时间',
          dataIndex: 'time'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GroupSentMessage', title: '群发消息' },
      { name: 'GroupSendList', title: '群发记录' },
      { name: 'AutoReplyList', title: '自动回复' }
    ])
  },
  methods: {
    onSearch(value) {
      this.queryParams.name = value
      this.$refs.table.refresh(true)
    },
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('wxMsg/v2/getList', params)
    },
    // 新增内容
    createCodeEvent(ruleId, status) {
      this.$router.push({
        name: 'AutoReplyRules',
        query: {
          groupId: ruleId,
          status: status,
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }

}
</script>
<style scoped lang="less">

</style>